import { Injectable } from '@angular/core';

import { filter, map, Observable } from 'rxjs';

import { ConfigRoutes } from '@ripeurs/common/types/gateway/common/routes/config';

import { ApiV2Service } from '~app/services/api-v2.service';

import type { ConfigType } from '@ripeurs/common/types/service/storage/config';


type FieldOperatorsValueType = ConfigType.FieldOperators['value']['FIELD_OPERATORS'];

@Injectable()
export class UtilityFieldOperatorsHandler {
	constructor(private readonly _api: ApiV2Service) {}

	public getFieldOperators(): Observable<FieldOperatorsValueType[]> {
		return this._api.request<ConfigRoutes.GetConfig.FieldOperatorsDef>(
			ConfigRoutes.GetConfig.config,
			{
				params: { type: 'fieldoperators' },
				query: { keys: ['FIELD_OPERATORS'], variant: 'fieldoperators' },
			},
		).pipe(
			filter(({ code }: { code: 'FOUND' | 'NOT_FOUND', data: { config: FieldOperatorsValueType[] } }) => code === 'FOUND'),
			map(({ data }: { data: { config: FieldOperatorsValueType[] } }) => {
				const fieldOperators = data.config ?? [];
				return fieldOperators.sort((a, b) => a.FULLNAME.localeCompare(b.FULLNAME));
			})
		);
	}
}
